import React, { CSSProperties, ReactNode } from "react";
import CardActionButton from "common/Lists/CardsList/CardActionButton";
import styled from "styled-components";
import { CardActionButtonProps } from "@shared/common/CardsList/types";

interface CardActionsProps {
  actionsData?: (CardActionButtonProps | React.JSX.Element)[];
  borderTop?: boolean;
  style?: CSSProperties;
  borderedButtons?: boolean;
  horizontalButtons?: boolean;
  size?: "m" | "l";
}

const CardActions = ({
  actionsData,
  borderTop,
  style,
  borderedButtons,
  horizontalButtons,
  size,
}: CardActionsProps) => {
  const actions = actionsData?.map((actionData, index) => {
    let button: ReactNode;
    if (React.isValidElement(actionData)) {
      button = actionData;
    } else {
      const castActionData = actionData as CardActionButtonProps;
      button = (
        <CardActionButton
          icon={castActionData.icon}
          text={castActionData.text}
          onClick={castActionData.onClick}
          invalid={castActionData.invalid}
          bordered={borderedButtons}
          horizontal={horizontalButtons}
          size={size}
        />
      );
    }
    return <ButtonWrapper key={index}>{button}</ButtonWrapper>;
  });

  return (
    <Wrapper $borderTop={borderTop} style={style}>
      {actions}
    </Wrapper>
  );
};

export default CardActions;

const Wrapper = styled.div<{ $borderTop?: boolean }>`
  display: flex;
  padding-bottom: 4px;
  ${(p) =>
    p.$borderTop &&
    `
  border-top: ${p.theme.borders.lightest};
  margin-top: 12px;
  padding: 10px 0 4px 0;
  `}
`;
const ButtonWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;
